import React from 'react';

import ClaimsTable from './ClaimsTable/ClaimsTable';
import ClaimsTableHeader from './ClaimsTable/ClaimsTableHeader';
import ClaimsTableRow from './ClaimsTable/ClaimsTableRow';
import { useClaimsShopSettings } from '../parcel-finder/ClaimsShopSettingsContext';
import { ListClaim } from '../../api/types';

import styles from './ClaimsCenterResults.scss';

type ClaimsCenterResultsProps = {
  claims: ListClaim[];
  onTakeActionButtonClick: (claim: ListClaim) => void;
  onCancelClaimButtonClick: (claim: ListClaim) => void;
  onContinueClaimSubmission: (claim: ListClaim) => void;
  tableHeaderTop?: number;
};

function ClaimsCenterResults(props: ClaimsCenterResultsProps) {
  const {
    claims,
    onTakeActionButtonClick,
    onCancelClaimButtonClick,
    onContinueClaimSubmission,
    tableHeaderTop,
  } = props;

  const { isDORSigningLinkEnabled, isPhotoCollectionAppEnabled } = useClaimsShopSettings();
  const showConsumerActionStatusFilter = isDORSigningLinkEnabled || isPhotoCollectionAppEnabled;

  return (
    <div className={styles.results}>
      <ClaimsTable showConsumerActionStatus={showConsumerActionStatusFilter}>
        <ClaimsTableHeader top={tableHeaderTop} />
        <tbody>
          {claims.map((claim) => (
            <ClaimsTableRow
              key={claim.id}
              claim={claim}
              onTakeActionButtonClick={onTakeActionButtonClick}
              onCancelClaimButtonClick={onCancelClaimButtonClick}
              onContinueClaimSubmission={onContinueClaimSubmission}
            />
          ))}
        </tbody>
      </ClaimsTable>
    </div>
  );
}

export default React.memo(ClaimsCenterResults);
